import React, { useState, useRef, useEffect } from 'react';

const ExternalSourceLite = ({ source, onDelete }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [title, setTitle] = useState(source.title);
  const inputRef = useRef(null);

  // Mettre à jour le titre local lorsque le titre de la source change
  useEffect(() => {
    setTitle(source.title);
  }, [source.title]);

  // Focus sur l'input lors de l'entrée en mode édition
  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  // Gérer le début de l'édition
  const handleEditStart = () => {
    setIsEditing(true);
  };

  // Gérer l'enregistrement des modifications
  const handleSave = () => {
    // On pourrait ajouter une fonction de mise à jour dans les props
    setIsEditing(false);
  };

  // Gérer la touche Entrée pendant l'édition
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSave();
    } else if (e.key === 'Escape') {
      setIsEditing(false);
      setTitle(source.title);
    }
  };

  // Déterminer les classes CSS en fonction de la position
  const sourceClasses = [
    'external-source',
    `position-${source.position}`
  ].join(' ');

  // Contenu de la source
  const sourceContent = isEditing ? (
    <input
      ref={inputRef}
      type="text"
      value={title}
      onChange={(e) => setTitle(e.target.value)}
      onBlur={handleSave}
      onKeyDown={handleKeyDown}
      className="external-source-input"
      onClick={(e) => e.stopPropagation()}
    />
  ) : (
    <div className="external-source-content" onClick={handleEditStart}>
      {title}
    </div>
  );

  return (
    <div className={sourceClasses}>
      {sourceContent}
      <button 
        className="external-source-delete" 
        onClick={onDelete}
        title="Supprimer"
      >
        ×
      </button>
    </div>
  );
};

export default ExternalSourceLite; 